import React from 'react';
import { array } from 'prop-types';
import cn from 'classnames';

import strings from '../../lang/lang';
import { Button } from '../../elements';
import Routes from '../../components/Routes';
import { appsActions } from '../../redux/reducers/apps';
import { ReactComponent as PlusIcon } from '../../styles/icon/plus-white.svg';
import { useAppDispatch } from '../../hooks/useRedux';

import app from './App.module.scss';
import AppCard from './AppCard';

AppList.propTypes = {
  appList: array,
};

function AppList(props) {
  const { appList } = props;
  const dispatch = useAppDispatch();

  return (
    <div className={cn(app.app, { [app.app__white]: !appList })}>
      <div className={app.app__container}>
        <div className={app.app__box}>
          <div className={app.app__title}>
            <h1>{strings.appList.text.title}</h1>
            <div className={app.app__btn_create}>
              <Button
                name={strings.appList.buttons.create}
                type="submit"
                variant="primary"
                className="reverse"
                secondaryClassName="create"
                onClick={() => dispatch(appsActions.toogleCreateAppModal(true))}
              >
                <PlusIcon />
              </Button>
            </div>
          </div>
          <div className={app.app__list_box}>
            <div className={app.app__list}>
              {appList.map((item) => {
                return (
                  <div className={app.app__item} key={item.id}>
                    <AppCard
                      link={Routes.routes.APPS.routes.CREDENTIALS.path.replace(':id', item.id)}
                      head={item.name + (item.status !== 'ACTIVE' ? ' (' + item.status + ')' : '')}
                      apiCount={item.apiCount}
                      desc={item.description}
                      createdDate={item.createdDate}
                      scopesInfo={item.scopes}
                      type={item.type}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppList;
